import { Stack } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";

import { UsersForm } from "@/features/dashboard/usuarios/components/UsersForm";

import { DashboardComponents } from "@/features/dashboard/_components/dashboard";

export const Route = createFileRoute("/_private/dashboard/_base/usuarios/cadastrar/")({
  component: RouteComponent
});

function RouteComponent() {
  return (
    <Stack>
      <DashboardComponents.Title>Cadastrar Usuário</DashboardComponents.Title>

      <UsersForm />
    </Stack>
  );
}
